import { useState } from 'react';

/**
 * How many rows a list shows, chosen by the reader and remembered.
 *
 * Jan asked (24.08.) for the people list to go past 50 because support reads
 * it top to bottom; every other list here has the same shape, so they all get
 * the same choice. 200 is the API's own ceiling (MAX_PAGE_SIZE) -- offering
 * more would just be clamped. The choice is stored per list: wanting 200
 * people says nothing about how many clubs fit on a screen.
 */
export const PAGE_SIZE_CHOICES = [25, 50, 100, 200] as const;

function stored(storageKey: string): number {
  const raw = Number(localStorage.getItem(storageKey));
  return PAGE_SIZE_CHOICES.includes(raw as (typeof PAGE_SIZE_CHOICES)[number])
    ? raw
    : 50;
}

export function usePageSize(list: string): [number, (next: number) => void] {
  const storageKey = `evalyte-admin.${list}.pageSize`;
  const [pageSize, setPageSize] = useState<number>(() => stored(storageKey));

  function update(next: number) {
    localStorage.setItem(storageKey, String(next));
    setPageSize(next);
  }

  return [pageSize, update];
}
